const isBrowser = typeof window !== 'undefined';
const isDevelopment = process.env.NODE_ENV === 'development';

const detectSameOrigin = (fallback) => {
    if (!isBrowser) return fallback;
    const { origin } = window.location;
    return origin || fallback;
};

// 환경변수로 URL 설정 (우선순위: 환경변수 > 런타임 감지 > 기본값)
const getApiUrl = () => {
    if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL;
    }

    // 개발 환경에서는 CRA dev server proxy를 사용하기 위해 상대 경로 사용
    if (isDevelopment) {
        return '';
    }

    return detectSameOrigin('https://118.39.232.190:8444');
};

const getGeoserverUrl = () => {
    if (process.env.REACT_APP_GEOSERVER) {
        return process.env.REACT_APP_GEOSERVER;
    }

    if (isDevelopment) {
        return '';
    }

    return detectSameOrigin('https://118.39.232.190:8445');
};

const getGeocoderApiUrl = () => {
    if (process.env.REACT_APP_GEOCODER_API) {
        return process.env.REACT_APP_GEOCODER_API;
    }

    if (isDevelopment) {
        return '';
    }

    if (isBrowser) {
        const { protocol, hostname } = window.location;
        return `${protocol}//${hostname}`;
    }

    return 'https://118.39.232.190:8449';
};

export const API_URL = getApiUrl();
export const GEOSERVER = getGeoserverUrl();
export const GEOCODER_API_URL = getGeocoderApiUrl();

// 현재 환경 정보 로깅 (개발 시에만)
// if (process.env.NODE_ENV === 'development') {
//     console.log('환경 설정:', {
//         NODE_ENV: process.env.NODE_ENV,
//         API_URL,
//         GEOSERVER,
//         REACT_APP_API_URL: process.env.REACT_APP_API_URL,
//         REACT_APP_GEOSERVER: process.env.REACT_APP_GEOSERVER,
//     });
// }
